export default __webpack_public_path__ + "static/media/sber-pay.fd6c6d0c.svg";